import api from './api';

export async function getAllOrganisations() {
    const res = await api.get('/Organisation');
    return res.data;
}

export async function createOrganisation(data) {
    const res = await api.post('/Organisation', data);
    return res.data;
}

export async function updateOrganisation(id, data) {
    const res = await api.patch(`/Organisation/${id}`, data);
    return res.data;
}

export async function deleteOrganisation(id) {
    const res = await api.delete(`/Organisation/${id}`);
    return res.data;
}

// The yearly Umsatzziel map ({ "2026": 600000 }). No org id in the path: the backend
// resolves it from the token, unlike /details and /branding.
export async function getRevenueTargets() {
    const res = await api.get('/Organisation/revenue-targets');
    return res.data;
}

// Replaced wholesale: a year dropped here loses its target.
export async function saveRevenueTargets(targets) {
    const res = await api.put('/Organisation/revenue-targets', { targets });
    return res.data;
}

export async function getAllUsers() {
    const res = await api.get('/User');
    return res.data;
}

export async function assignUserOrganisation(userId, organisationId) {
    const res = await api.patch(`/User/${userId}/organisation`, { organisation_id: organisationId });
    return res.data;
}

export async function updateUserRole(userId, role) {
    const res = await api.patch(`/User/${userId}`, { role });
    return res.data;
}

export async function createUser(data) {
    const res = await api.post('/User', data);
    return res.data;
}

export async function deleteUser(userId) {
    const res = await api.delete(`/User/${userId}`);
    return res.data;
}

export async function updateUser(userId, data) {
    const res = await api.patch(`/User/${userId}`, data);
    return res.data;
}

export async function toggleUserActive(userId, isActive) {
    const res = await api.patch(`/User/user_active_state_change/${userId}/${isActive}`, {});
    return res.data;
}
